import CustomZObject from './CustomZObject.js';

export default class JTypes extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("choose", () => this.onChoose());
        this.newInlet("set probabilities", ([x]) => this.setProbabilities(x));
        this.newOutlet("choice");
        this.newOutlet("probabilities");
       
        this.probabilities = {
            rest: 0,
            pianissimo: 0,
            piano: 0,
            regular: 0,
            accent: 0,
            staccato: 0,
            legato: 0,
            double: 0,
            flam: 0,
        };
    }

    setProbabilities(probabilities) {
        let keys = Object.keys(this.probabilities);
        for (let i=0; i < probabilities.length; i++) {
            this.setProbability(
                keys[i], probabilities[i]);
        }
        this.probabilities = {... this.probabilities};
    }

    getJson() {
        return {
            ... super.getJson(),
            probabilities: this.probabilities
        }
    }

    fromJson(json, ...args) {
        super.fromJson(json, ...args);
        this.probabilities = json.probabilities;
    }

    setProbability(type, probability) {
        this.probabilities[type] = probability;

        this.sendMessage("probabilities", Object.values(normalize(this.probabilities)));
    }

    onChoose() {
        let normalized = normalize(this.probabilities);
        let flip = Math.random();
        let min=0;
        for (let t in normalized) {
            if (flip < min + normalized[t]) {
                this.sendMessage("choice", t);
                return;
            }
            min += normalized[t];
        }
    }
}

const normalize = (p) => {
    let total = 0;
    for (let t in p) {
        total += p[t];
    }
    let normalized = {};
    for (let t in p) {
        normalized[t] = p[t]/total;
    }
    return normalized;
};

